import { render, staticRenderFns } from "./InvitationRecords.vue?vue&type=template&id=341c5ae8&scoped=true"
import script from "./InvitationRecords.vue?vue&type=script&lang=js"
export * from "./InvitationRecords.vue?vue&type=script&lang=js"
import style0 from "./InvitationRecords.vue?vue&type=style&index=0&id=341c5ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341c5ae8",
  null
  
)

export default component.exports